import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";

type ComponentPropsType = {
  duration: number;
  onComplete: () => void;
};

function CountDownTimer({ duration, onComplete }: ComponentPropsType) {

  const [ remaining, setRemaining ] = useState(duration);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setRemaining(prev => {
        const newRemaining = prev - 1;
        if (newRemaining === 0) {
          if (intervalRef.current) clearInterval(intervalRef.current);
        }
        return newRemaining;
      });
    }, 1000);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (remaining === 0) {
      onComplete?.();
    }
  }, [ remaining, onComplete ]);

  return (
    <>
      {_.padStart(String(Math.floor(remaining / 60)), 2, "0")}:{_.padStart(String(remaining % 60), 2, "0")}
    </>
  );
}

export default React.memo(CountDownTimer);
